import React, { useState, useEffect } from 'react'
import NumberFormat from 'react-number-format'

// estilos
import './catalog.css';
import '../../assets/style/componentPrincipal.css'

// componentes
import { Buscar } from '../general/buscadorCatalog/Buscar'
import { ModalProgress } from '../modals/ModalProgress'
import { ExportExcel } from '../general/exportarPlanilla/ExportExcel'
// import { VerReporte } from '../general/verReporte/VerReporte'
import { Crear } from './Crear'
import { DialogProfileCatalog } from './DialogProfileCatalog'

import { useCatalog } from '../../hooks/useCatalog'
import { Pagination } from '@mui/material';
import { DialogListaCategorias } from './DialogListaCategorias';
import { Link } from 'react-router-dom';

export const CatalogListServicios = () => {

    const { catalog, handleNew, handleUpdate, initLoadCatalog, initExport } = useCatalog()
    const loading = false
    const [openCategorias, setOpenCategorias] = useState(false)

    const [filters, setFilters] = useState({
        estado: true,
        text: '',
        check_venta: false,
        check_compra: false,
        check_activo: true,
        check_desactivo: false,
        id_categoria: '',
        page: 1,
        rows: 10
    })

    useEffect(() => {
        initLoadCatalog(filters)
    }, [filters, initLoadCatalog])

    return (
        <div className='p-container'>
            <h1 className='p-title'>Servicios</h1>

            <div className='row p-box-searching'>
                <div className='col d-flex'>
                    <Buscar
                        filters={filters}
                        setFilters={setFilters}
                    />
                    <div className='p-box-crear'>
                        <Crear
                            handleNew={handleNew}
                        />
                    </div>
                </div>
                <div className='col d-flex justify-content-end'>
                    <ExportExcel
                        filters={filters}
                        initExport={initExport}
                    />
                    {/* <VerReporte /> */}
                </div>
            </div>

            {/* <div>
                <button
                    className='p-open-condicion mt-2'
                    onClick={() => setOpenCategorias(true)}>
                    Ver categorías
                </button>
            </div> */}

            <div className='row p-box-filters'>
                <div className='col p-box-filters-items'>
                    <Link to="/catalogo" className='selected'>Servicios</Link>
                    <Link to="/catalogo/cat">Ver categorías</Link>
                </div >
            </div>

            {loading && <ModalProgress />}

            <div className='row'>
                <div className='col d-flex flex-wrap justify-content-start'>
                    <List
                        handleUpdate={handleUpdate}
                        catalog={catalog}
                        filters={filters}
                        setFilters={setFilters}
                        initLoadCatalog={initLoadCatalog}
                    />
                </div>
            </div>

            {openCategorias &&
                <DialogListaCategorias
                    open={openCategorias}
                    setOpen={setOpenCategorias}
                />
            }

        </div >
    )
}

const List = ({ catalog, handleUpdate, filters, setFilters, initLoadCatalog }) => {

    const [open, setOpen] = useState(false)
    const [initialState, setInitialState] = useState({})
    const [page, setPage] = useState(1)

    const getOne = async (item) => {
        setInitialState(item)
        setOpen(true)
    }

    const handleChange = (event, value) => {
        setPage(value)
        setFilters({
            ...filters,
            page: value
        })
    }

    return (
        <div className='p-table'>

            <div className="row">
                <div className="col d-flex justify-content-end">
                    <Pagination
                        count={10}
                        page={page}
                        size="small"
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="table-responsive">
                <table className="table p-table-global">
                    <thead className='p-thead-global'>
                        <tr className="text-center p-tr-titles-global" style={{ verticalAlign: 'middle' }}>
                            <th className='text-start'>Nombre servicio</th>
                            <th className='text-start'>Categoría</th>
                            <th>Cod. servicio</th>
                            <th>Tipo</th>
                            <th className='text-end'>Precio de venta</th>
                            <th className='text-end'>Precio de compra</th>
                            <th className='text-end'>Total utilidad</th>
                            <th>Margen</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {catalog?.length > 0 && catalog?.map(item => (
                            <ItemList
                                item={item}
                                getOne={getOne}
                            />
                        ))}
                    </tbody>
                </table>
            </div>

            {open && (
                <DialogProfileCatalog
                    open={open}
                    setOpen={setOpen}
                    initialState={initialState}
                    handleUpdate={handleUpdate}
                    handleNew={null}
                    initLoadCatalog={initLoadCatalog}
                />
            )}

        </div>
    )
}

const ItemList = ({ item, getOne }) => {
    // console.log('--item--', item)
    return (
        <tr
            key={item.id}
            className='p-tr-body-global'
            style={{ textTransform: 'capitalize', cursor: 'pointer', textDecoration: !item.estado ? 'line-through' : '' }}
        >
            <td className="text-start" onClick={() => getOne(item)}>
                {item.codigo ?
                    <span>{item.servicio}{' / '}{item.codigo}</span>
                    :
                    <span>{item.servicio}</span>
                }
            </td>
            <td className="text-start" onClick={() => getOne(item)}>
                {item.codigo_categoria ? (item.categoria + " / " + item.codigo_categoria) : (item.categoria || '---')}
            </td>
            <td className="text-center" onClick={() => getOne(item)}>{item.codigo || '---'}</td>
            <td className="text-center" onClick={() => getOne(item)}>{item.tipo || '---'}</td>
            <td className="text-end" onClick={() => getOne(item)}>
                <NumberFormat
                    value={item.precio_venta || '---'}
                    displayType={'text'}
                    thousandSeparator={','}
                    decimalSeparator={'.'}
                    prefix={'S/'}
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </td>
            <td className="text-end" onClick={() => getOne(item)}>
                <NumberFormat
                    value={item.precio_costo || '---'}
                    displayType={'text'}
                    thousandSeparator={','}
                    decimalSeparator={'.'}
                    prefix={'S/'}
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </td>
            <td className="text-end" onClick={() => getOne(item)}>
                <NumberFormat
                    value={item.total_utilidad || '---'}
                    displayType={'text'}
                    thousandSeparator={','}
                    decimalSeparator={'.'}
                    prefix={'S/'}
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </td>
            <td className="text-center" onClick={() => getOne(item)}>
                <NumberFormat
                    value={item.margen_utilidad || '---'}
                    displayType={'text'}
                    thousandSeparator={','}
                    decimalSeparator={'.'}
                    suffix='%'
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </td>
            <td className="text-center">{item.estado ? 'Habilitado' : 'Desactivado'}</td>
        </tr>
    )

}